export default "__VITE_ASSET__B0$c$RS0__"